import { useEffect, useRef } from 'react';

export const useChanged = <T>(value: T) => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current !== value;
};
